import { SortMeta } from "primeng/api/sortmeta";

export class TableCode {

    // table definition
    codeData: any[] = []; // Code table data
    codeCols: any[];    // Code table columns

    blockData: any[] = []; // Block table data
    blockCols: any[];    // block table columns

    // sort
    sortOrder: SortMeta[];

    constructor() {

        this.codeCols = [
            { field: 'npanxxx', header: 'Code', width: '6' },
            { field: 'ocn', header: 'OCN', width: '5', toolTip:'OCN for the code owner from LERG6' },
            { field: 'ocnName', header: 'OCN Name', width: '16' },
            { field: 'spid', header: 'SPID', width: '5.5' },
            { field: 'spName', header: 'SP Name', width: '16' },
            { field: 'region', header: 'Region', width: '6' },
            { field: 'state', header: 'State', width: '5' },
            { field: 'lerg6Switch', header: 'Switch', width: '8' },
            { field: 'rc', header: 'Rate Center', width: '12' },
            { field: 'lata', header: 'LATA', width: '6' },
            { field: 'lataName', header: 'LATA Name', width: '14.5' },
        ];

        this.blockCols = [
            { field: 'npanxxx', header: 'Block', width: '7' },
            { field: 'active', header: 'Active', width: '6', toolTip:'Indicates if there is an active Number Pool Block' },
            { field: 'eTime', header: 'Effective Date/Time (ET)', width: '14.5', toolTip:'The effective date/time for the NPA-NXX-X from NPAC' },
            { field: 'contaminated', header: 'Contaminated', width: '9.5', toolTip:'Indicates if there is at least one ported TN record within the block' },
            { field: 'spid', header: 'SPID', width: '5.5', toolTip:'NPAC SPID for the block owner' },
            { field: 'spName', header: 'SP Name', width: '14.5' },
            { field: 'ocn', header: 'OCN', width: '5.5', 'toolTip':'OCN for the block owner form LERG6' },
            { field: 'ocnName', header: 'OCN Name', width: '14.5' },
            { field: 'altSpid', header: 'Alt SPID', width: '7' },
            { field: 'laltSpid', header: 'Last Alt SPID', width: '9' },
            { field: 'lrn', header: 'LRN', width: '7', toolTip:'LRN for an active Number Pool Block' },
        ];

        // set default sort order
        this.sortOrder = [{ field: 'block', order: 1 }];
    }

}

